import { FC } from 'react'
import { ScoreGoalDto, ScoreGridsOverviewDto } from '../../types'
import { EvaluationScoreGridEntry } from './EvaluationScoreGridEntry'
import { OwnGrowthGridCategory } from './OwnGrowthGridCategory'

type Props = {
  evaluationOverview: ScoreGridsOverviewDto
  activeCategory: OwnGrowthGridCategory
  privateView?: boolean
}

export const EvaluationScoreGridContainer: FC<Props> = ({ evaluationOverview, activeCategory, privateView = false }) => {
  const { lastAppraisalDate, lastAppraisalEmplPrepDate, priorAppraisalDate, scoreGoals } = evaluationOverview

  const goals = scoreGoals.filter((goal) => goal.viewId.includes(activeCategory))

  const renderScoreGridEntry = (goal: ScoreGoalDto, index: number) => (
    <EvaluationScoreGridEntry
      key={goal.viewId}
      score={goal}
      lastAppraisalDate={lastAppraisalDate}
      lastAppraisalEmplPrepDate={lastAppraisalEmplPrepDate}
      priorAppraisalDate={priorAppraisalDate}
      divider={index < goals.length - 1}
      privateView={privateView}
    />
  )

  return <div>{goals.map(renderScoreGridEntry)}</div>
}
